"use strict";

function _typeof(obj) { "@babel/helpers - typeof"; if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.A11yProvider = A11yProvider;
exports.focusNextTrappedElement = focusNextTrappedElement;
exports.default = void 0;

var _react = _interopRequireWildcard(require("react"));

var _propTypes = _interopRequireDefault(require("prop-types"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _getRequireWildcardCache() { if (typeof WeakMap !== "function") return null; var cache = new WeakMap(); _getRequireWildcardCache = function _getRequireWildcardCache() { return cache; }; return cache; }

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") { return { default: obj }; } var cache = _getRequireWildcardCache(); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj.default = obj; if (cache) { cache.set(obj, newObj); } return newObj; }

function _toConsumableArray(arr) { return _arrayWithoutHoles(arr) || _iterableToArray(arr) || _unsupportedIterableToArray(arr) || _nonIterableSpread(); }

function _nonIterableSpread() { throw new TypeError("Invalid attempt to spread non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }

function _iterableToArray(iter) { if (typeof Symbol !== "undefined" && Symbol.iterator in Object(iter)) return Array.from(iter); }

function _arrayWithoutHoles(arr) { if (Array.isArray(arr)) return _arrayLikeToArray(arr); }

function _slicedToArray(arr, i) { return _arrayWithHoles(arr) || _iterableToArrayLimit(arr, i) || _unsupportedIterableToArray(arr, i) || _nonIterableRest(); }

function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }

function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }

function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) { arr2[i] = arr[i]; } return arr2; }

function _iterableToArrayLimit(arr, i) { if (typeof Symbol === "undefined" || !(Symbol.iterator in Object(arr))) return; var _arr = []; var _n = true; var _d = false; var _e = undefined; try { for (var _i = arr[Symbol.iterator](), _s; !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"] != null) _i["return"](); } finally { if (_d) throw _e; } } return _arr; }

function _arrayWithHoles(arr) { if (Array.isArray(arr)) return arr; }

var A11yContext = /*#__PURE__*/(0, _react.createContext)();
var TABBABLE_ELEMENT_SELECTOR = ['input:not([disabled]):not([type=hidden])', 'select:not([disabled])', 'textarea:not([disabled])', 'button:not([disabled])', 'a[href]', 'area[href]', 'summary', 'iframe', 'object', 'embed', 'audio[controls]', 'video[controls]', '[contenteditable]', '[tabindex]'].join(':not([tabindex="-1"]),');
/**
 * Provides functions to register and unregister focusable elements
 * as well as an array of all registered focusable elements.
 * @param {Object} props - props
 * @return {ReactElement} chidlren
 */

function A11yProvider(_ref) {
  var children = _ref.children;

  var _useState = (0, _react.useState)([]),
      _useState2 = _slicedToArray(_useState, 2),
      focusableElements = _useState2[0],
      setFocusableElements = _useState2[1];

  var registerElement = (0, _react.useCallback)(function (element) {
    var exists = focusableElements.find(function (focusableElement) {
      return focusableElement === element;
    });

    if (!element || exists) {
      return;
    }

    setFocusableElements(function (prevElements) {
      return [].concat(_toConsumableArray(prevElements), [element]);
    });
  }, [focusableElements]);
  var unregisterElement = (0, _react.useCallback)(function (element) {
    if (!element) {
      return;
    }

    setFocusableElements(function (prevElements) {
      return prevElements.filter(function (focusableElement) {
        return focusableElement !== element;
      });
    });
  }, []);
  var value = (0, _react.useMemo)(function () {
    return {
      focusableElements: focusableElements,
      registerElement: registerElement,
      unregisterElement: unregisterElement
    };
  }, [focusableElements, registerElement, unregisterElement]);
  return /*#__PURE__*/_react.default.createElement(A11yContext.Provider, {
    value: value
  }, children);
}

A11yProvider.propTypes = {
  children: _propTypes.default.node
};
/**
 * Traps focus inside an element and focuses the next or previous tabbable element found.
 * @param {HTMLElement} element - container element
 * @param {SyntheticEvent} event - event object
 * @return {undefined}
 */

function focusNextTrappedElement(element, event) {
  var key = event.key,
      shiftKey = event.shiftKey,
      target = event.target,
      type = event.type;

  if (!element) {
    return;
  }

  if (type === 'keydown' && key === 'Tab') {
    var nodeList = element.querySelectorAll(TABBABLE_ELEMENT_SELECTOR) || [];
    var tabbableElements = Array.from(nodeList);
    var index = tabbableElements.findIndex(function (el) {
      return el === target;
    });
    var direction = shiftKey ? -1 : 1;
    var tabbable = tabbableElements[(index + direction + tabbableElements.length) % tabbableElements.length];

    if (tabbable) {
      event.preventDefault();
      event.stopPropagation();
      tabbable.focus();
    }
  }
}

var _default = A11yContext;
exports.default = _default;